import styled from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';
import { ControlButton } from 'ui/components/ControlButton/ControlButton';

export const StyledButton = styled(ControlButton)<{ $isDisabled: boolean; $isTransparent: boolean }>`
    background-color: ${(props) => (props.$isTransparent ? 'transparent' : props.theme.root.colors.basicColors['6%'])};
    border: ${(props) => (props.$isTransparent ? `1px solid ${props.theme.root.colors.basicColors['10%']}` : 'none')};
    cursor: ${(props) => (props.$isDisabled ? 'default' : 'pointer')};
    padding: 8px 12px;
    max-height: 40px;
    gap: 6px;

    &:active {
        border: 1px solid ${(props) => props.theme.root.colors.basicColors['10%']};
    }
`;

export const StyledIcon = styled(Icon)`
    margin-right: 2px;
`;

export const Description = styled.div`
    display: block;
    margin-top: 2px;
    height: 16px;
`;
